<div class="input-file-container d-flex">
	<button valgButton color="text-only-without-padding" class="mr-4" (click)="onClick()">{{placeholder | translate}}</button>
	<div class="text text--medium" *ngIf="file">{{file.name}}</div>
	<input #input [id]="id" type="file" (change)="onInputChange()"/>
</div>

